import config from "./config";
var axios = config();

export default {
  getMessages() {
    return axios.get("/api/messages", {});
  }
};
